import type { ModuleType } from "@typedefs/interfaces"
import { ModuleShared } from "@typedefs/modulesInterfaces"

export interface IrrigationResponse extends ModuleShared {
	id: number
	module_type: ModuleType
}

export interface IrrigationPayload extends ModuleShared {
	id: number | null,
	area: number | null
}

export interface IrrigationT2Payload {
	soc_t2_start: number | null
	soc_t2_w: number | null
	soc_t2_wo: number | null
}

export interface IrrigationUpdatePayload {
	body: IrrigationPayload & IrrigationT2Payload
	activityId: number
}

export interface ModuleFull {
	module: IrrigationPayload,
	tiertwo: IrrigationT2Payload,
	irrigations: IrrigationSystemResponse[],
	irrigationPhases: IrrigationPhaseResponse[]
}

export interface IrrigationsUpdatePayload {
	data: ModuleFull,
	activityId: number
}

/* TODO: check these fields  */
export interface IrrigationSystemResponse extends ModuleShared {
	id: number,
	parent: number,

	irrigation_system_type: number | null,
	ha_start: number | null,
	ha_w: number | null,
	ha_wo: number | null,

	ef_t2_start: number | null,
	ef_t2_w: number | null,
	ef_t2_wo: number | null,

	irrigation_system_type_thread: number | null,
	ha_thread: number | null,
	module_type: ModuleType | null,
}

export interface IrrigationSystem {
	irrigation_system_type: number | null,
	ha_start: number | null,
	ha_w: number | null,
	ha_wo: number | null,
	irrigation_system_type_thread: number | null,
	ha_thread: number | null,
}

export interface IrrigationSystemT2 {
	ef_t2_start: number | null,
	ef_t2_w: number | null,
	ef_t2_wo: number | null,
}

export interface IrrigationSystemDefaults {
	ef_t2_start_default: number | null,
	ef_t2_w_default: number | null,
	ef_t2_wo_default: number | null,
}

export interface IrrigationSystemPayload {
	body: IrrigationSystemResponse,
	activityId: number
}
export interface IrrigationSystemCreatePayload {
	body: { parent: number },
	activityId: number
}
export interface IrrigationSystemDeletePayload {
	id: number,
	activityId: number,
	parent: number | null
}
export interface IrrigationPhaseResponse extends ModuleShared {
	id: number,
	module_type: ModuleType | null,
	parent: number,

	irrigation_system_type: number | null,
	fuel_type_start: number | null,
	fuel_type_w: number | null,
	fuel_type_wo: number | null,
	well_depth: number | null,
	ha_start: number | null,
	ha_w: number | null,
	ha_wo: number | null,
	gross_irrigation_water_start: number | null,
	gross_irrigation_water_w: number | null,
	gross_irrigation_water_wo: number | null,

	country: number | null,
	ef_co2_t2_start: number | null,
	ef_co2_t2_w: number | null,
	ef_co2_t2_wo: number | null,
	ef_ch4_t2_start: number | null,
	ef_ch4_t2_w: number | null,
	ef_ch4_t2_wo: number | null,
	ef_n2o_t2_start: number | null,
	ef_n2o_t2_w: number | null,
	ef_n2o_t2_wo: number | null,
	transmission_loss_t2_start: number | null,
	transmission_loss_t2_w: number | null,
	transmission_loss_t2_wo: number | null,
	average_pressure_t2: number | null,
	total_dynamic_head_t2: number | null,
	pumping_efficiency_t2_start: number | null,
	pumping_efficiency_t2_w: number | null,
	pumping_efficiency_t2_wo: number | null,
	power_origin_country_t2: number | null

	irrigation_system_type_thread: number | null,
	fuel_type_thread: number | null,
	well_depth_thread: number | null,
	ha_thread: number | null,
	gross_irrigation_water_thread: number | null,
}

export interface IrrigationPhase {
	irrigation_system_type: number | null,
	well_depth: number | null,
	fuel_type_start: number | null,
	fuel_type_w: number | null,
	fuel_type_wo: number | null,
	ha_start: number | null,
	ha_w: number | null,
	ha_wo: number | null,
	gross_irrigation_water_start: number | null,
	gross_irrigation_water_w: number | null,
	gross_irrigation_water_wo: number | null,

	irrigation_system_type_thread: number | null,
	fuel_type_thread: number | null,
	well_depth_thread: number | null,
	ha_thread: number | null,
	gross_irrigation_water_thread: number | null,
}

export interface IrrigationPhaseT2 {
	country: number | null,
	ef_co2_t2_start: number | null,
	ef_co2_t2_w: number | null,
	ef_co2_t2_wo: number | null,
	ef_ch4_t2_start: number | null,
	ef_ch4_t2_w: number | null,
	ef_ch4_t2_wo: number | null,
	ef_n2o_t2_start: number | null,
	ef_n2o_t2_w: number | null,
	ef_n2o_t2_wo: number | null,
	transmission_loss_t2_start: number | null,
	transmission_loss_t2_w: number | null,
	transmission_loss_t2_wo: number | null,
	average_pressure_t2: number | null,
	total_dynamic_head_t2: number | null,
	pumping_efficiency_t2_start: number | null,
	pumping_efficiency_t2_w: number | null,
	pumping_efficiency_t2_wo: number | null,
	power_origin_country_t2: number | null
}

export interface IrrigationPhasePayload {
	body: IrrigationPhaseResponse,
	activityId: number
}
export interface IrrigationPhaseCreatePayload {
	body: { parent: number },
	activityId: number
}
export interface IrrigationPhaseDeletePayload {
	id: number,
	activityId: number,
	parent: number | null
}
export interface IrrigationPhaseDefaults {
	// country_default: number | null,
	ef_co2_t2_start_default: number | null,
	ef_co2_t2_w_default: number | null,
	ef_co2_t2_wo_default: number | null,
	ef_ch4_t2_start_default: number | null,
	ef_ch4_t2_w_default: number | null,
	ef_ch4_t2_wo_default: number | null,
	ef_n2o_t2_start_default: number | null,
	ef_n2o_t2_w_default: number | null,
	ef_n2o_t2_wo_default: number | null,
	transmission_loss_t2_start_default: number | null,
	transmission_loss_t2_w_default: number | null,
	transmission_loss_t2_wo_default: number | null,
	average_pressure_t2_default: number | null,
	total_dynamic_head_t2_default: number | null,
	pumping_efficiency_t2_start_default: number | null,
	pumping_efficiency_t2_w_default: number | null,
	pumping_efficiency_t2_wo_default: number | null,
	power_origin_country_t2_default: number | null
}

export enum Irrigations {
	IrrigationSystem = 'module.new_irrigation_system',
	OperationPhase = 'module.operation_phase_of_irrigation'
}